import { httpGet, httpPost } from "../httpService/httpService";

export const getUsers = async (apiBase: string) => {

    return new Promise((resolve, reject) => {
        httpGet(`${apiBase}/process/get-users`)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getUsersByRoles = async (apiBase: string, editors: boolean) => {

    return new Promise((resolve, reject) => {
        httpGet(`${apiBase}/process/${editors ? "get-to-assign-editors" : "get-to-assign-verifies"}`)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getDefaultUser = async (apiBase: string, waitingRoomRecs: any[], isEditor: boolean, isTerytDefault: boolean, teryt?: string) => {
    
    const formData = new FormData();
    formData.append('WaitingRoomRecs', JSON.stringify(waitingRoomRecs));
    formData.append('IsEditor', JSON.stringify(isEditor));
    formData.append('IsTerytDefault', JSON.stringify(isTerytDefault));
    formData.append('Teryt', teryt ? teryt : "");
    
    return new Promise((resolve, reject) => {
        httpPost(`${apiBase}/process/get-default-user`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const assignEditor = async (apiBase: string, editor: any, waitingRoomRecs: any[], verifierToggleStatus?: string) => {
    
    const formData = new FormData();
    formData.append('Editor', JSON.stringify(editor));
    formData.append('WaitingRoomRecs', JSON.stringify(waitingRoomRecs));
    formData.append('VerifierToggleStatus', verifierToggleStatus ? verifierToggleStatus : '');

    return new Promise((resolve, reject) => {
        httpPost(`${apiBase}/process/assign-editor`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const assignVerifier = async (apiBase: string, verifier: any, waitingRoomRecs: any[]) => {
    
    const formData = new FormData();
    formData.append('Verifier', JSON.stringify(verifier));
    formData.append('WaitingRoomRecs', JSON.stringify(waitingRoomRecs));

    return new Promise((resolve, reject) => {
        httpPost(`${apiBase}/process/assign-verifier`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getAnalysisErrorDetails = async (apiBase: string, waitingRoomGlobalId: string) => {
    return new Promise((resolve, reject) => {
        httpGet(`${apiBase}/process/${waitingRoomGlobalId}/get-error-details`).then((data: any) => {
            resolve(data.data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}